import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=6d5caf95&scoped=true&"
import script from "./balance.vue?vue&type=script&lang=js&"
export * from "./balance.vue?vue&type=script&lang=js&"
import style0 from "./balance.vue?vue&type=style&index=0&id=6d5caf95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5caf95",
  null
  
)

export default component.exports